import React from 'react'
import { useCard } from '@orbital/games-frontend-library'
import { handleCardSuit } from './helpers/useCardSuit'

export default function CardContent({ card }: any) {
  const { handleCardSymbol } = useCard()

  return (
    <>
      <p>{handleCardSymbol(card)}</p>
      {handleCardSuit(card)}
    </>
  )
}
